import styled from '../../../../styles/theme';
import NeedHelpSectionStyled from '../NeedHelpSectionStyled';
import { rem } from 'polished';

const NeedHelpSectionStyledAC = styled(NeedHelpSectionStyled)`
    .need-help-section__title {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        line-height: ${rem(28)};
    }
    .need-help-section__link {
        &.need-help-section__phone {
            color: ${({ theme }) => theme.colors.red} !important;
        }
        &.need-help-section__faq{
            color: ${({ theme }) => theme.colors.red} !important;
        }
        
    }
    .need-help-section__link__icon {
        svg {
            path {
                fill: ${({ theme }) => theme.colors.primary};
            }
        }
    }
    
    .icon-wrapper {
        height: ${({ theme }) => theme.fontSizes.h4}; !important;
    }

    background: ${({ theme }) => theme.colors.white};
    color: #3C3947;
`;

export default NeedHelpSectionStyledAC;
